import { INITIALIZE_FORM } from '../actionTypes';
import { createAttachmentModalActions } from '../reducer';

export default (values) =>
    createAttachmentModalActions[INITIALIZE_FORM](values);
